import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { withHermes } from 'ha/modules/Hermes';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { highlightRoom, unhighlightRoom } from 'ha/pages/Search/actions';
import trackSearchResults from 'ha/pages/Search/actions/trackSearchResults';
import SearchResults from 'ha/pages/Search/components/SearchResults';
import {
  getListings,
  hasCitiesNearby,
  getPageInfo,
  getAnalyticsForFilters,
  getAnalyticsForListings,
  getCountryCode,
  getCityCanonical,
  getCountryCanonical,
  getCityName,
  getCountryName,
} from 'ha/pages/Search/selectors';
import { SuggestionBarActions } from '../actions';
import { withIntl } from 'ha/i18n';
import { GlobalState } from 'ha/types/store';

const noop = () => {
  //
};

function onScrollChange({ scrollTop }: { scrollTop: number }) {
  return scrollTop >= 800 ? SuggestionBarActions.show() : noop;
}

export default compose(
  connect(
    (state: GlobalState) => ({
      items: getListings(state),
      pageInfo: getPageInfo(state),
      countryCode: getCountryCode(state),
      cityCanonical: getCityCanonical(state),
      countryCanonical: getCountryCanonical(state),
      shouldShowCitiesNearby: hasCitiesNearby(state),
      isAuthenticated: getIsAuthenticated(state),
      filtersAnalytics: getAnalyticsForFilters(state),
      listingsAnalytics: getAnalyticsForListings(state),
      cityLocalizedName: getCityName(state),
      countryLocalizedName: getCountryName(state),
    }),
    {
      onHighlight: highlightRoom,
      onUnhighlight: unhighlightRoom,
      onScrollChange,
      trackSearchResults,
    },
  ),
  withIntl,
  withRouter,
  withHermes,
)(SearchResults);
